import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";
import { getMsgStatusInOrder, removeTempMute, setTempMute } from "../../Helpers/Chat/ChatHelper";
import { emptyMessage, updateRecall } from "../../Helpers/Chat/Recall";
import { MEDIA_MESSAGE_TYPES } from "../../Helpers/Constants";
import { StateToObj } from "./reduxHelper"
const initialState = {
}
const getNames = (data=[]) =>{
    return data.map((ele)=>(
        ele.fromUserId
    ))
}
const _stateConversion = (_state) => {
    return JSON.parse(JSON.stringify(_state))
}
const updateRecentChatFunc = (filterBy, newMessage, _state) => {
    const {   data : recentChatArray = []  } = _stateConversion(_state)
    const checkalreadyExist = recentChatArray.find((message) => message.fromUserId === filterBy);
    if (!checkalreadyExist) {
      newMessage.archiveStatus = 0;
      return [...recentChatArray, newMessage];
    }
    let value =  recentChatArray.map((recentItem) => {
      if (recentItem.fromUserId === filterBy) {
        return {
          ...recentItem,
          ...newMessage,
          deleteStatus: 0
        };
      }
      return recentItem;
    });
    return value
  };

  const updateRecentChatMessageStatusFunc = (data, stateData) => {
    const { data:stateDataArr } = stateData
    return stateDataArr.map((element) => {
      if (element.fromUserId === data.fromUserId && element.msgId === data.msgId) {
        element.msgStatus = getMsgStatusInOrder(element.msgStatus, data.msgStatus);
      }
      return element;
    });
  };

  const updateMuteRecentChat = (data, stateData) => {
    let i = 0;
    const newstate = stateData.map((element) => {
      if (element.fromUserId === data.fromUserId) {
        element.muteStatus = data.isMuted ? 1 : 0;
      } else {
        i++;
      }
      return element;
    });
    if (i === newstate.length - 1 || i === newstate.length) {
      if (data.isMuted) setTempMute(data.fromUserId, true);
    }
    if (!data.isMuted) {
      removeTempMute(data.fromUserId);
    }
    return newstate;
  };

  const updateReconnectRecentChatData = (newRecentChat, oldRecentChat = []) => {
    const { data:oldRecentChatData } = oldRecentChat
    const pendingMsgChats = oldRecentChatData.filter((chat) => {
      return chat.msgStatus === 3 && MEDIA_MESSAGE_TYPES.includes(chat.msgType);
      // //if (chat.msgStatus === 3 && MEDIA_MESSAGE_TYPES.includes(chat.msgType)) return true;
      // //return false;
    });
  
    let reconnectNewData =  newRecentChat.map((recentItem) => {
      const pendingChat = pendingMsgChats.find((pending) => pending.fromUserId === recentItem.fromUserId);
      if (pendingChat) {
        return {
          ...pendingChat,
          ...recentItem
        };
      } else {
        return {
          ...recentItem
        };
      }
    });
    return reconnectNewData;
  };
  
  const clearMessageInRecentChat = (state,chatId) =>{
    const recentData =  state?.data
    return recentData.map((element) => {
      if (element.fromUserId === chatId) {
        return {
          ...element,
             msgBody : {},
             msgType : "",
             createdAt : "",
             msgStatus : 4
        } 
      }
      return element;
    });
  }
  const deletedChatList = (deleteData, currentArray) => {
    const { fromUserId } = deleteData;
    return currentArray.filter((element, id) => element["fromUserId"] !== fromUserId);
  };

  const updateMsgByLastMsgId = (newMessage, recentChatList = []) => {
    const msgIndex = recentChatList.findIndex((msg) => msg.lastMsgId === newMessage.msgId);
    if (msgIndex > -1) {
      recentChatList[msgIndex] = { ...recentChatList[msgIndex], ...newMessage };
      recentChatList[msgIndex]["msgType"] = newMessage?.msgBody?.message_type || newMessage.msgType;
    }
    return recentChatList.sort((a, b) => (b.msgId > a.msgId ? 1 : -1));
  };
  
const recentChatData = createSlice({
    name:'recentChatData',
    initialState,
    reducers:{
        addRecentChat: (_state,payload)=>{
          return {
          "id" : uuidv4(),
          "data": payload.payload,
          "rosterData":{
              "recentChatNames":getNames(payload.payload)
            }
          }
        },
        addRecentRosterUpdate:(_state, payload)=>{    
          return {
            ..._state,
            "rosterUpdate":{
              "recentChatItems": payload.payload
            }          
          }
        },
        updateRecentChat: (_state,payload)=>{
            const { filterBy, ...rest } = payload.payload
            return {
            ..._state,
             "id" : uuidv4(),
             "data": updateRecentChatFunc(filterBy, rest, _state)
            }
     },
     updateRecentChatMessageStatus: (_state,payload)=>{
      return {
        ..._state,
         "id" : uuidv4(),
         "data": updateRecentChatMessageStatusFunc(payload.payload,StateToObj(_state))
        }
     },
     updateReconnectData:(_state,payload)=>{
      return {
        ..._state,
         "id" : uuidv4(),
         "data": updateReconnectRecentChatData(payload.payload,StateToObj(_state))
      }
     },
     clearLastMessageinRecentChat:(_state,payload)=>{
      return {
        ..._state,
        "id" : uuidv4(),
        "data": clearMessageInRecentChat(StateToObj(_state), payload.payload)
      }
     },
     deleteMessageinRecentChat:(_state,payload)=>{
     return {
       ..._state,
       "id" : uuidv4(),
       "data": deletedChatList(payload.payload,StateToObj(_state).data)
     }
    },
     logOutRecentChat: (_state,payload)=>{
      return initialState;
    },
    recentRemoveMessageUpdate:(_state,payload)=>{
      return {
        ..._state,
        "id" : uuidv4(),
        "data": emptyMessage(payload.payload,StateToObj(_state).data)
      };
    },
    updateRecentMsgByLastMsgId:(_state,payload)=>{
      return {
        ..._state,
        "id" : uuidv4(),
        "data": updateMsgByLastMsgId(payload.payload,StateToObj(_state).data),
      };
    },
    recentRecallUpdate:(_state,payload)=>{
      return {
        ..._state,
        "id" : uuidv4(),
        "data": updateRecall(payload.payload,StateToObj(_state).data),
      };
    },
    updateMuteStatusRecentChat:(_state,payload)=>{
      return {
        ..._state,
        "id" : uuidv4(),
        "data": updateMuteRecentChat(payload.payload,StateToObj(_state).data),
      };
    }
    }
});

export default recentChatData.reducer
export const addRecentChat = recentChatData.actions.addRecentChat  
export const updateRecentChat = recentChatData.actions.updateRecentChat  
export const updateRecentChatMessageStatus = recentChatData.actions.updateRecentChatMessageStatus
export const updateReconnectData = recentChatData.actions.updateReconnectData
export const logOutRecentChat = recentChatData.actions.logOutRecentChat
export const addRecentRosterUpdate = recentChatData.actions.addRecentRosterUpdate
export const clearLastMessageinRecentChat = recentChatData.actions.clearLastMessageinRecentChat
export const deleteMessageinRecentChat = recentChatData.actions.deleteMessageinRecentChat
export const recentRemoveMessageUpdate = recentChatData.actions.recentRemoveMessageUpdate
export const updateRecentMsgByLastMsgId = recentChatData.actions.updateRecentMsgByLastMsgId
export const recentRecallUpdate = recentChatData.actions.recentRecallUpdate
export const updateMuteStatusRecentChat = recentChatData.actions.updateMuteStatusRecentChat